import { render, staticRenderFns } from "./imgtext.vue?vue&type=template&id=a6d2bd78&scoped=true&"
import script from "./imgtext.vue?vue&type=script&lang=js&"
export * from "./imgtext.vue?vue&type=script&lang=js&"
import style0 from "./imgtext.vue?vue&type=style&index=0&id=a6d2bd78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d2bd78",
  null
  
)

export default component.exports